import { makeStyles } from '@material-ui/core';
import { Typography } from '@mui/material';
import React from 'react';

const useStyles = makeStyles(() => ({
  styledTypeCard: {
    width: '60px',
    height: '20px',
    padding: '4px 8px',
    borderRadius: '4px',
    background: '#622fee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  styledTypeText: {
    fontFamily: 'Lato',
    fontSize: '10px !important',
    fontWeight: '600 !important',
    lineHeight: '14px',
    textAlign: 'center',
    color: '#fefefe',
  },
}));

const QuestionChip = ({ title }) => {
  const classes = useStyles();

  return (
    <div className={classes.styledTypeCard}>
      <Typography className={classes.styledTypeText}>{title}</Typography>
    </div>
  );
};

export default QuestionChip;
